// extracted by mini-css-extract-plugin
module.exports = {"wrapperContent":"PopoverElement_wrapperContent__1McbA","wrapperBody":"PopoverElement_wrapperBody__3NdnM","wrapperFooter":"PopoverElement_wrapperFooter__2ibYZ"};